(() => {
  if (window.iBidLeadAnalytics) return;
  const destination = 'G-6TRCDVETKD';
  const storageKey = 'ibidAnalyticsReceipts:v1';
  const ttl = 30 * 60 * 1000;
  const pending = new Map();
  const dispatched = new Set();
  const waiters = new Map();
  let ready = false;
  let probing = false;
  let restored = false;
  let lastPhone = { href: '', time: 0 };

  function status(value) {
    try { document.documentElement.dataset.ibidAnalyticsStatus = value; } catch {}
  }

  function allowed() {
    try {
      return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true;
    } catch {
      return false;
    }
  }

  function persist() {
    if (!allowed()) return;
    try {
      sessionStorage.setItem(storageKey, JSON.stringify({
        pending: Array.from(pending.values()).slice(-20),
        dispatched: Array.from(dispatched).slice(-100)
      }));
    } catch {}
  }

  function restore() {
    if (restored || !allowed()) return;
    restored = true;
    try {
      const saved = JSON.parse(sessionStorage.getItem(storageKey) || '{}');
      for (const id of saved.dispatched || []) dispatched.add(id);
      for (const item of saved.pending || []) {
        if (item && Date.now() - item.time < ttl && !dispatched.has(item.id)) pending.set(item.id, item);
      }
    } catch {}
  }

  function settle(id, status) {
    const resolve = waiters.get(id);
    if (resolve) {
      waiters.delete(id);
      resolve(status);
    }
  }

  function flush() {
    if (!allowed()) { status('awaiting_analytics_permission'); return; }
    restore();
    if (typeof window.gtag !== 'function') { status('tag_unavailable'); return; }
    if (!ready) {
      status('awaiting_tag');
      if (probing) return;
      probing = true;
      setTimeout(() => { probing = false; }, 2000);
      try {
        window.gtag('get', destination, 'client_id', (clientId) => {
          probing = false;
          if (!clientId || !allowed()) return;
          ready = true;
          flush();
        });
      } catch { probing = false; }
      return;
    }
    status('ready');
    for (const item of Array.from(pending.values())) {
      if (Date.now() - item.time >= ttl || dispatched.has(item.id)) {
        pending.delete(item.id);
        settle(item.id, 'expired_or_duplicate');
        continue;
      }
      if (!allowed()) return;
      pending.delete(item.id);
      dispatched.add(item.id);
      persist();
      try {
        window.gtag('event', item.name, {
          ...item.params,
          send_to: destination,
          transport_type: 'beacon',
          event_timeout: 1000,
          event_callback: () => { status('event_processed'); settle(item.id, 'processed'); }
        });
      } catch {
        dispatched.delete(item.id);
        pending.set(item.id, item);
        persist();
        settle(item.id, 'pending');
      }
    }
  }

  function enqueue(id, name, params) {
    restore();
    if (dispatched.has(id)) return Promise.resolve('duplicate');
    if (pending.has(id)) return Promise.resolve('pending');
    pending.set(id, { id, name, params, time: Date.now() });
    if (pending.size > 20) pending.delete(pending.keys().next().value);
    persist();
    const result = new Promise((resolve) => {
      waiters.set(id, resolve);
      setTimeout(() => settle(id, 'pending_or_blocked'), 1200);
    });
    flush();
    return result;
  }

  function submission(functionName, result) {
    if (result?.status !== 'received' || result.existing === true) return Promise.resolve('not_a_new_save');
    let receipt;
    let name;
    let formId;
    let leadType;
    if (functionName === 'submitShopifySellerSubmission' && result.submission_id && result.machine_id) {
      receipt = result.submission_id;
      name = 'lp_contact_form_submission';
      formId = 'IbidSellMachineryForm';
      leadType = 'seller_machinery';
    } else if (functionName === 'submitBuyerInquiry' && result.inquiry_id) {
      receipt = result.inquiry_id;
      name = 'buyer_inquiry_submission';
      formId = 'IbidProductContact';
      leadType = 'buyer_machinery';
    } else if (functionName === 'submitBuyerRequest' && result.request_id) {
      receipt = result.request_id;
      name = 'buyer_request_submission';
      formId = 'IbidWantedForm';
      leadType = 'buyer_request';
    } else return Promise.resolve('incomplete_receipt');
    return enqueue(functionName + ':' + String(receipt), name, {
      form_id: formId,
      lead_type: leadType,
      submission_status: 'saved'
    });
  }

  document.addEventListener('click', (event) => {
    if (!event.isTrusted || event.defaultPrevented) return;
    const target = event.target?.closest?.('a[href^="tel:"]');
    if (!target) return;
    const href = target.getAttribute('href') || '';
    const now = Date.now();
    if (href === lastPhone.href && now - lastPhone.time < 750) return;
    lastPhone = { href, time: now };
    const placement = target.closest('header') ? 'header' : target.closest('footer') ? 'footer' : target.closest('main') ? 'main' : 'other';
    void enqueue('phone:' + now + ':' + Math.random().toString(36).slice(2), 'phone_click', {
      contact_method: 'phone',
      link_location: placement,
      lead_type: 'contact_intent'
    });
  });

  document.addEventListener('visitorConsentCollected', () => {
    if (!allowed()) {
      pending.clear();
      try { sessionStorage.removeItem(storageKey); } catch {}
      for (const id of waiters.keys()) settle(id, 'consent_denied');
      return;
    }
    persist();
    flush();
  });
  window.addEventListener('pageshow', flush);
  window.iBidLeadAnalytics = { submission };
  if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (!error) flush();
    });
  }
  restore();
  flush();
  let attempts = 0;
  const interval = setInterval(() => {
    flush();
    if (++attempts >= 15) clearInterval(interval);
  }, 2000);
})();
